<script setup lang="ts">
import { DgrIcon } from '@stockmarkteam/donguri-ui';
import TextTabItem from '@/components/common/molecules/text-tab-item.vue';
import ToggleSwitch, {
  ToggleSwitchItem,
} from '@/components/common/molecules/toggle-switch.vue';
import { DocType } from '@/types';
import { docTypeDisplayNameMap } from '@/utils/adpDocument';

withDefaults(
  defineProps<{
    showPreviewTitle?: boolean;
    isForeignFeedAvailable: boolean;
    isTechnicalLiteratureAvailable: boolean;
    toggleSwitchItem: ToggleSwitchItem;
    isCompact?: boolean;
  }>(),
  { showPreviewTitle: true, isCompact: false },
);

const emit = defineEmits<{ toggleFeedType: [] }>();

const docType = defineModel<DocType>('docType', { required: true });
const allDocTypes: DocType[] = ['article', 'research_paper', 'patent'];
const docTypeDisplayNameMapForThemePreview = {
  ...docTypeDisplayNameMap,
  article: 'ニュース',
};
const toggleSwitchHandler = () => {
  emit('toggleFeedType');
};
</script>

<template>
  <div class="preview-container">
    <div
      class="title c-title-bold--m"
      :class="{ 'hide-preview-title': !showPreviewTitle }"
    >
      プレビュー
      <DgrIcon
        size="small"
        name="question-circle"
        v-tooltip.top="{
          content: '設定した条件に基づき、最新の記事を最大50件まで表示します。',
          theme: 'menu',
        }"
      />
    </div>
    <ToggleSwitch
      class="m-feed-switch"
      :class="{ compact: isCompact }"
      v-if="isForeignFeedAvailable"
      :toggle-switch-item="toggleSwitchItem"
      @toggle-switch="toggleSwitchHandler"
    ></ToggleSwitch>
    <div v-if="isTechnicalLiteratureAvailable" class="tab-list">
      <div v-for="docTypeTab in allDocTypes" :key="docTypeTab">
        <TextTabItem
          :text="docTypeDisplayNameMapForThemePreview[docTypeTab]"
          :is-selected="docTypeTab === docType"
          :has-notification="undefined"
          @click-tab="() => (docType = docTypeTab)"
        ></TextTabItem>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.m-feed-switch {
  width: 391px;
  &:not(.compact) {
    margin-bottom: 16px;
  }
}

.title {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  opacity: 1;
  height: 100%;
  transform: translateY(0);
  // margin-bottomは他より少し遅くて上下の動きに滑らかさをだす
  transition:
    opacity 0.1s linear,
    transform 0.1s linear,
    height 0.1s linear,
    margin-bottom 0.15s linear;

  .icon-box {
    margin-left: 4px;
  }
}

.hide-preview-title {
  opacity: 0;
  transform: translateY(-100%);
  height: 0;
  margin-bottom: 0;
}

.tab-list {
  display: flex;
  border-bottom: 1px solid $color-gray400;
}
</style>
